import React, { useMemo, useCallback } from 'react';
import { Select } from '@iq/react-components';

const DisplayPropertiesPicker = ({
  disabled,
  readonly,
  required,
  value,
  schema: { isMulti, placeholder },
  options: { enumOptions = [] },
  onChange,
  ...properties
}) => {
  const getLabel = (value_) => (enumOptions.find((o) => o.value === value_) || {}).label;

  const theValue = useMemo(() => {
    if (typeof value === 'boolean') {
      return { label: getLabel(value), value: value.toString() };
    }
    return { label: getLabel(value), value };
  }, [value]);

  const setValues = useCallback(
    ({ value: value_ }) => {
      const v = (() => {
        if (value_ === 'true') return true;
        if (value_ === 'false') return false;
        return null;
      })();
      onChange(v);
    },
    [onChange]
  );

  const stringOptions = enumOptions.map((o) => ({
    ...o,
    value: o.value === null ? null : o.value.toString(),
  }));

  const overrideStyles = {
    container: (base) => ({ ...base, lineHeight: 'normal' }),
    singleValue: (base) => ({ ...base, lineHeight: 'normal' }),
    control: (base) => ({ ...base, lineHeight: 'normal' }),
  };

  return (
    <Select
      isMulti={isMulti}
      closeMenuOnSelect={!isMulti}
      disabled={disabled}
      readOnly={readonly}
      required={required}
      placeholder={placeholder}
      defaultValue={theValue}
      onChange={setValues}
      options={stringOptions}
      styles={overrideStyles}
      {...properties}
    />
  );
};

export default DisplayPropertiesPicker;
